import { render, staticRenderFns } from "./SubjectCreate.vue?vue&type=template&id=6cf15ccb&scoped=true&"
import script from "./SubjectCreate.vue?vue&type=script&lang=js&"
export * from "./SubjectCreate.vue?vue&type=script&lang=js&"
import style0 from "./SubjectCreate.vue?vue&type=style&index=0&id=6cf15ccb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf15ccb",
  null
  
)

export default component.exports